import * as React from 'react';
import cx from 'classnames';

// @ts-ignore
import { fetchJSONFileByIdRequest, V2File } from 'clients/api/fileUploads';
import Icon from 'components/Icon';
import MediaObject from 'components/MediaObject';
import Text from 'components/Text';
// @ts-ignore
import TranslatableText from 'chat/components/TranslatableText';

import './styles/MockAnnouncementChubble.scss';

type Props = {
  senderName: string;
  senderSubtext: string;
  senderAvatar: React.ReactElement<any>;
  messageBody: string;
  fileAttachmentUuids?: string[];
  isUrgent?: boolean;
};

type State = {
  uploadedFile?: V2File;
};

type FileTypeIcon = 'image' | 'mic' | 'file' | 'play-circle';

export default class MockAnnouncementChubble extends React.Component<Props, State> {
  state: State = {};

  componentDidMount() {
    if (this.props.fileAttachmentUuids) {
      this.fetchFileIntoState(this.props.fileAttachmentUuids[0]);
    }
  }

  fetchFileIntoState = async (fileUuid: any) => {
    const uploadedFile = await fetchJSONFileByIdRequest(fileUuid);
    this.setState({ uploadedFile });
  };

  render() {
    const { uploadedFile } = this.state;
    return (
      <Text align="left" element="div">
        <div className="AnnouncementMessageItem AnnouncementMessageItem-other">
          <div className="AnnouncementMessageItem-column">
            <div className="AnnouncementMessageItem-dropletChubble">
              <div className="AnnouncementMessageItem-chubble">
                <MediaObject
                  center
                  gutter="xxsmall"
                  className={cx(
                    'AnnouncementMessageItem-head',
                    this.props.isUrgent && 'AnnouncementMessageItem-head--urgent'
                  )}>
                  {React.cloneElement(this.props.senderAvatar, {
                    className: 'AnnouncementMessageItem-announcementBadge',
                  })}
                  <div className="AnnouncementMessageItem-head-classInfo">
                    <Text weight="semibold" color="pitch" truncate>
                      {this.props.senderName}
                    </Text>
                    <Text color="thunder" truncate>
                      {this.props.senderSubtext}
                    </Text>
                  </div>
                </MediaObject>
                <div className="AnnouncementMessageItem-content">
                  <div className="MessageItemBody-body MessageItemBody-body--mock">
                    <TranslatableText initialText={this.props.messageBody} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {uploadedFile && (
          <div className="MockAnnouncementChubble-fileAttachment">
            <MediaObject center gutter="small">
              <div className="MockAnnouncementChubble-fileAttachment-icon">
                <Icon name={getIconForFileType(uploadedFile.content_type)} />
              </div>
              <Text>{uploadedFile.name}</Text>
            </MediaObject>
          </div>
        )}
      </Text>
    );
  }
}

function getIconForFileType(fileType: string): FileTypeIcon {
  if (fileType.includes('image')) {
    return 'image';
  }

  if (fileType.includes('video')) {
    return 'play-circle';
  }

  if (fileType.includes('audio')) {
    return 'mic';
  }

  return 'file';
}
